export default "https://cdn-web.disco.co/slack-accordion-background-714617ade1682337e1954f5c18d97c15.png";